/** Strips non-digit characters and caps length — shared by every digit-masked input field. */
export function sanitizeDigits(raw: string, maxLength: number): string {
  return raw.replace(/\D/g, '').slice(0, maxLength);
}
